import { RootState } from '../store/create-store';
import { SeriesState } from 'store/series/types';

export const getSeriesState = (state: RootState): SeriesState => state.series;
